// extracted by mini-css-extract-plugin
export default {"tempo":"TempoBoxBanner-module_tempo_CQupOhlpOy","background":"TempoBoxBanner-module_background_htVzbvacWa","tempoBoxBanner":"TempoBoxBanner-module_tempoBoxBanner_LgX4arx_pG"};